'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSyncDisabled = function MdSyncDisabled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 6.6l-4 4c2.4 2.4 4 5.7 4 9.4 0 2.6-0.8 5-2.1 7l-2.5-2.4c0.7-1.4 1.2-3 1.2-4.6 0-2.7-1.2-5.2-3-7l-3.6 3.6v-10h10z m-28.6 2.4l2.1-2.1 26.1 26.2-2.1 2.1-3.9-3.9c-1.1 0.7-2.4 1.3-3.7 1.6v-3.4c0.4-0.2 0.9-0.4 1.3-0.7l-13.4-13.4c-0.7 1.4-1.2 3-1.2 4.6 0 2.7 1.2 5.2 3 7l3.6-3.6v10h-10l4-4c-2.4-2.4-4-5.7-4-9.4 0-2.6 0.8-5 2.1-7z m11.8 1.5c-0.4 0.2-0.8 0.4-1.2 0.7l-2.4-2.5c1.1-0.7 2.3-1.3 3.6-1.6v3.4z' })
        )
    );
};

exports.default = MdSyncDisabled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/sync-disabled.js
// module id = 1520
// module chunks = 36573943044255 79611799117203 213534597649335